import React, { useState } from "react";
import { Link } from "react-router-dom";
import useResetScroll from "../../utils/useResetScroll";

// Account deletion page linked from Google Play (Data safety > delete account URL).
// Two ways: in the app (Profile > Privacy & Data > Delete My Data), or an email request to support.
const SUPPORT_EMAIL = "otatokyo.official@gmail.com";

const DeleteUser = () => {
  useResetScroll();
  const [email, setEmail] = useState("");

  const subject = encodeURIComponent("Delete my Ōta LIFE account");
  const body = encodeURIComponent(
    `Please delete my Ōta LIFE account.\n\nAccount email (Google, Apple or email login): ${email}\n\nI am sending this from the email address of the account.`,
  );
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;

  return (
    <div className="min-h-[100svh] bg-gradient-to-b from-[#F5F3FF] to-white px-5 py-10">
      <div className="mx-auto max-w-lg text-sm leading-relaxed text-gray-700">
        <h1 className="text-2xl font-extrabold text-gray-900">Delete your Ōta LIFE account</h1>
        <p className="mt-2">Ōta LIFE (by Ōta TOKYO). You can delete your account and its data at any time.</p>

        <h2 className="mt-6 text-base font-bold text-gray-900">Option 1: in the app</h2>
        <ol className="mt-2 list-decimal space-y-1 pl-5">
          <li>Open the Ōta LIFE app and log in.</li>
          <li>Go to <b>Profile</b> &gt; <b>Privacy &amp; Data</b>.</li>
          <li>Tap <b>Delete My Data</b> and confirm.</li>
        </ol>

        <h2 className="mt-6 text-base font-bold text-gray-900">Option 2: by email</h2>
        <p className="mt-2">
          No access to the app? Email us from the address of your account and we will delete it for you.
        </p>
        <input
          type="email"
          placeholder="Your account email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-3 w-full rounded-xl border border-gray-300 p-3"
        />
        <a
          href={mailto}
          className="mt-3 block w-full rounded-xl bg-red-600 py-3 text-center font-bold text-white"
          data-testid="delete-request"
        >
          Email a deletion request
        </a>
        <p className="mt-2 text-xs text-gray-500">
          Or write to {SUPPORT_EMAIL}, or <Link className="underline" to="/contact?topic=delete-account">send us a message through our Contact page</Link>.
        </p>

        <h2 className="mt-6 text-base font-bold text-gray-900">What happens</h2>
        <ul className="mt-2 list-disc space-y-1 pl-5">
          <li>Your account is closed right away and permanently deleted after 90 days. Contact us within those 90 days to cancel.</li>
          <li>Deleted: your profile, login details, posts, comments, community memberships, points, rewards and app settings.</li>
          <li>Kept: records of paid orders and tickets (amount, date, order ID), for as long as tax and accounting law requires. They are no longer linked to a usable account.</li>
        </ul>

        <div className="mt-10 flex gap-4 text-xs text-gray-400">
          <a href="/privacy-policy">Privacy Policy</a>
          <Link to="/contact">Contact</Link>
        </div>
      </div>
    </div>
  );
};

export default DeleteUser;
